
import React from "react";

interface EstimationSummaryProps {
  totalComponents: number;
  devDays: number;
  totalDays: number;
}

const EstimationSummary: React.FC<EstimationSummaryProps> = ({ 
  totalComponents, 
  devDays, 
  totalDays 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      <div className="bg-purple-50 dark:bg-gray-800 p-4 rounded-lg text-center">
        <div className="text-sm text-gray-600 dark:text-gray-400">Total Components</div>
        <div className="text-2xl font-bold text-purple-700 dark:text-purple-300">
          {totalComponents}
        </div>
      </div>
      <div className="bg-purple-50 dark:bg-gray-800 p-4 rounded-lg text-center">
        <div className="text-sm text-gray-600 dark:text-gray-400">Dev Days</div>
        <div className="text-2xl font-bold text-purple-700 dark:text-purple-300">
          {devDays.toFixed(1)}
        </div>
      </div>
      <div className="bg-purple-50 dark:bg-gray-800 p-4 rounded-lg text-center">
        <div className="text-sm text-gray-600 dark:text-gray-400">Total Days</div>
        <div className="text-2xl font-bold text-purple-700 dark:text-purple-300">
          {totalDays.toFixed(1)}
        </div>
      </div>
    </div>
  );
};

export default EstimationSummary;
